import Loadable from "react-loadable";

export const DeleteCompanyButton = Loadable({
  loader: () => import("../../../../modules/manage-profile").then((module) => module.DeleteCompanyButton) as Promise<any>,
  loading: () => null,
});
